// store/vesselsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const vesselsSlice = createSlice({
  name: "vessels",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    setVessels(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearVessels(state) {
      state.data = [];
    },
  },
});

export const { setVessels, setLoading, setError, clearVessels } =
  vesselsSlice.actions;

export default vesselsSlice.reducer;
